export const UserRoutes = {
  Dashboard: '/dashboard',
  Reclamations: '/reclamations',
  Performance: '/performance'
};

export const AdminRoutes = {
  AdminDashboard: '/admin-dashboard'
};
